<template>
  <div>
    <section class="register-photo" style="background: rgb(255,255,255);">
      <b-container>
        <b-row class="justify-content-md-center">
            <form v-on:submit.prevent="register">
              <ul class="nav nav-tabs">
                <li class="nav-item">
                  <a class="nav-link" :class="{ active : tab == 2}" @click="tab = 2" href="javascript:;">Kurumsal (LTD. A.Ş için seçiniz.)</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" :class="{ active : tab == 1}" @click="tab = 1" href="javascript:;">Bireysel (Sadece Şahıs Ödemeleri)</a>
                </li>
              </ul>
              <div class="tab-content">
                  <b-row>
                    <b-col md="6" cols="12">
                        <b-form-group label="Adınız (*)">
                          <b-form-input size="sm" v-model="form.name"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" cols="12">
                        <b-form-group label="Soyadınız (*)">
                          <b-form-input size="sm" v-model="form.surname"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" cols="12">
                        <b-form-group label="E-Mail Adresiniz (*)">
                          <b-form-input size="sm" placeholder="test@gmail.com" v-model="form.email"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" cols="12">
                        <b-form-group label="Telefon (*)">
                          <b-form-input size="sm" type="number" onKeyDown="if(this.value.length==11 && event.keyCode!=8) return false;" placeholder="05xx xxx xx xx" v-model="form.phone"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" cols="12">
                        <b-form-group label="Şifreniz (*)">
                          <b-form-input type="password" size="sm" v-model="form.password"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" cols="12">
                        <b-form-group label="Şifreniz Tekrar. (*)">
                          <b-form-input type="password" size="sm" v-model="form.password_confirmation"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" cols="12">
                        <b-form-group label="Vergi Dairesi">
                          <b-form-input size="sm" v-model="form.tax_place"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" cols="12" v-if="tab == 2">
                        <b-form-group label="Vergi Numarası (*)">
                          <b-form-input type="number" size="sm" onKeyDown="if(this.value.length==10 && event.keyCode!=8) return false;" v-model="form.tax_number"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" cols="12" v-if="tab == 1">
                        <b-form-group label="TC Kimlik Numarası (*)">
                          <b-form-input type="number" size="sm" onKeyDown="if(this.value.length==11 && event.keyCode!=8) return false;" v-model="form.identity_id"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group label="Adres (*)">
                          <b-form-input size="sm" placeholder="Mahalle, Cadde, Sokak, Kapı No ..." v-model="form.address"></b-form-input>
                        </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                      <hr class="mt-2">
                      <div class="col-md-6 mb-3">
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" id="exampleCheck1" name="cancel_void_accept" value="1" required="">
                          <label class="form-check-label" for="exampleCheck1" style="font-size:12px;">
                            <router-link :to="{ name : 'Page', params : { slug: 'gizlilik-politikasi'}}"><strong>Üyelik koşulları</strong></router-link>'nı onaylıyorum.</label>
                        </div>
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" id="exampleCheck2" name="kvkk_accept" value="1" required="">
                          <label class="form-check-label" for="exampleCheck2" style="font-size:12px;"><router-link :to="{ name : 'Page', params : { slug: 'kvkk-aydinlatma-metni'}}"><strong>KVKK Aydınlatma Metni</strong></router-link>'ni onaylıyorum.</label>
                        </div>
                      </div>
                      <div class="col-md-6 mb-3" style="text-align:right">
                        <button :loader="isLoading"  class="btn btn-primary pull-right" style="margin-top:10px; text-align:right;" type="submit">Kayıt Ol</button>
                      </div>
                </b-row>
              </div>
            </form>
        </b-row>
      </b-container>
    </section>
  </div>
</template>
<script>
  import { mapState, mapActions } from "vuex";
  export default{
    name: 'Register',
    data(){
      return{
        tab: 1,
        isLoading: false,
        form:{
          name: null,
          surname: null,
          email:null,
          phone: null,
          company_name: null,
          password:null,
          password_confirmation:null,
          tax_place:null,
          tax_number:null,
          identity_id:null,
          address:null,
          type: 1,
        }
      }
    },
    methods:{
      ...mapActions("auth", ["login"]),

      register() {
        this.isLoading = true;
        this.form.type = this.tab;
        let form = Object.assign({}, this.form);
        axios.post('/auth/register', { ...form })
        .then((response)=>{
          this.login(form);
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false;
        });
      },
    },
  }
</script>
